

export const getDescriptionTemplate = ({
  title,
  description,
  supplierType,
  forLocationId,
}: {
  title: string;
  description: string;
  supplierType: string;
  forLocationId: string;
}) => {
  const deliveryPart = (() => {
    if (supplierType === 'FR_ilyes') {
      if (forLocationId === 'toulouse') {
        return `▸ Livraison & retrait, en stock à Toulouse`;
      } else {
        return '▸ Livraison 4 jours depuis Toulouse';
      }
    }

    return '▸ Livraison gratuite en 7 jours';
  })();
  return `   Wow Magasin
  Magasin professionnel
∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎

▸ Produit NEUF
${deliveryPart}
▸ Retours gratuits sous 14 jours
▸ Achat sécurisé via le paiement Leboncoin

∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎

${title || ''}


${description || ''}

∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎∎

▸ "Livraison personalisée" = livraison avec UPS à domicile en 1-4 jours

❓ Questions ? N'hésitez pas à me contacter !
Disponible par télephone ou par messagerie instantanée
`;
};